/**
 * Cryoport booking UI — synthetic transport id (no Courier row required).
 * Allowed companies are gated in the frontend (separate list from World Courier).
 */
export const CRYOPORT_TRANSPORT_PROVIDER_ID = 'CRYOPORT';

export const CRYOPORT_ALLOWED_COMPANY_IDS = new Set<string>([
  '95b618d1-75c8-4323-ba8e-e0af61261132',
  'fa0e11b7-8eda-41a5-94ca-4a59515b9388',
  '22a3e579-3a38-4596-b725-b05a6f71ec85',
]);

export function isCryoportCompany(
  companyId: string | null | undefined
): boolean {
  return CRYOPORT_ALLOWED_COMPANY_IDS.has(String(companyId ?? ''));
}
